import { Collapse } from "antd";
import React, { useEffect, useState } from "react";
import faq from "../img/inner-desktop-banners/blessings-inner-faq-banner.webp"
import faqmobile from "../img/inner-mobile-banners/faq-mobile-banner.webp"

import GetApiCall from "../API/GETAPI";
// import GetSeoData from "../../helpers/GetSeoData";
import "./Faq.css";
import GetSeoData from "../API/GetSeoData";
export default function Faq() {
  const [Faq, setFaq] = useState([]);
  useEffect(() => {
    GetApiCall.getRequest("GetJsonFAQS").then((results) => {
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          setFaq(obj.data);
        }
      });
    });
    // GetApiCall.getRequest("GetFAQS").then((results) => {
    //   results.json().then((obj) => {
    //     if (results.status === 200 || results.status === 201) {
    //       setFaqData(obj.data);
    //     }
    //   });
    // });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <GetSeoData type="FAQ" id={null} />
      <section className="inner-section faq-page appointment-page position-relative">
        <img
          alt="About Banner"
          src={window.innerWidth > 568 ? faq : faqmobile}
          className="img-fluid w-100"
        />
        <h1>Frequently Asked Questions (FAQ's)</h1>
        {/* <NavBar /> */}
        {/* <div className="page-title-area">
          <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-center">
            <div className="page-title-content">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Book An Appointment</li>
              </ul>
            </div>
          </div>
        </div> */}
      </section>
      <section className="spacing blank-section py-4">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-lg-5">
              <img
                // src={FAQIm}
                className="img-fluid w-100 h-100"
                alt=""
              />
            </div> */}
            <div className="col-lg-12 faq-accordion">
              <h1 className="mb-0 text-center">
                We have answered few of the commonly asked questions
              </h1>
              <p className="text-center">
                Common Questions About Your Astrological Journey
              </p>
              {/* <Collapse accordion items={items} /> */}
              {Faq.length
                ? Faq?.map((data) => {
                  return (
                    <Collapse
                      accordion
                      items={[
                        {
                          key: data.fld_id,
                          label: (
                            <h6 className="mb-0">{data.fld_question}</h6>
                          ),
                          children: data.fld_answer,
                        },
                      ]}
                    ></Collapse>
                  );
                })
                : ""}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
